export function formatCurrency (number, options) {
    return (['number', 'string'].includes(typeof number)) ? new Intl.NumberFormat('de-CH', Object.assign({ style: 'currency', currency: 'CHF' }, options)).format(number) : number
}
